import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function FinalCtaSection() {
  return <section className="py-32 bg-terracotta text-white relative overflow-hidden" data-id="element-72">
      {/* Background texture */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-terracotta-dark via-terracotta to-terracotta opacity-80" data-id="element-73" />

      <div className="container mx-auto px-6 max-w-4xl text-center relative z-10" data-id="element-74">
        <FadeIn data-id="element-75">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight" data-id="element-76">
            El Patrón Se Detiene Contigo.
          </h2>
          <p className="font-body text-xl text-white/90 mb-4 max-w-2xl mx-auto" data-id="element-77">
            No tienes que seguir cargando lo que no te pertenece. Hoy puedes
            elegir un camino diferente.
          </p>
          <p className="font-heading text-2xl md:text-3xl italic text-white/95 mb-12 max-w-2xl mx-auto" data-id="element-78">
            No los honras cargando su dolor. Los honras dejando de repetirlo.
          </p>
          <Button href="#pricing" size="lg" className="bg-white text-terracotta hover:bg-beige-light shadow-2xl" data-id="element-79">
            Quiero romper este patrón →
          </Button>
        </FadeIn>
      </div>
    </section>;
}